import React, {useEffect, useState, useRef} from 'react';
import { connect } from 'react-redux';
import { FaCar, FaMale, FaPlay, FaPause, FaBackward, FaForward, FaExpand, FaCompress } from 'react-icons/fa';
import player_poster from '../../player_poster.png';
import loader_poster from '../../loader.gif';

const VideoPlayer = props => {
  const player = useRef()
  const slider = useRef()
  const speeds = ['.25', '.5', 1, 2, 5, 10] // max value depends on the browser, 20 throws an error, saw something that some have max 16
  const [videoLoaded, setVideoLoaded] = useState(false)
  const [playing, setPlaying] = useState(false)
  const [time, setTime] = useState('')
  const [speed, setSpeed] = useState(1)
  const [showSpeedOptions, setShowSpeedOptions] = useState(false)
  const [fullscreen, setFullscreen] = useState(false)
  const [contextMenu, setContextMenu] = useState([])

  useEffect(() => {
    const handleVideoEvent = (event) => {
      if (event.type === 'loadeddata') {
        player.current.play()
        player.current.poster = player_poster
        setPlaying(true)
        setVideoLoaded(true)
      } else if (event.type === 'ended') {
        setPlaying(false)
      }
    }

    if (player.current) {
      setPlaying(false)
      setVideoLoaded(false)
      player.current.src = props.selectedVideoPlayingUrl
      if (props.selectedVideoPlayingUrl && props.selectedVideoPlayingUrl.length > 0) {
        player.current.poster = loader_poster
        player.current.defaultPlaybackRate = 1
        player.current.addEventListener('loadeddata', handleVideoEvent)
        player.current.addEventListener("ended", handleVideoEvent)
        player.current.load()
      } else {
        player.current.poster = player_poster
      }
    }
  }, [props.selectedVideoPlayingUrl]);

  useEffect(() => {
    const getVideoTime = () => {
      if (player.current) {
        const formattedTime = formatTime(player.current.currentTime)
        setTime(formattedTime)
      }
    }
    const videoTimer = setInterval(getVideoTime, 800)
    return () => clearInterval(videoTimer)
  }, [time])

  const formatTime = (secs) => {
    const t = Math.round(secs)
    const hours = Math.round(t / 3600)
    const minutes = Math.round((t % 3600) / 60).toString().padStart(2, '0')
    const seconds = (t % 60).toString().padStart(2, '0')
    const formattedTime = (hours > 0 ? hours.toString().padStart(2, '0') + ':' : '') + minutes + ':' + seconds
    return formattedTime
  }

  const formatTS = (ts) => {
    return new Date(ts).toLocaleDateString('en-us', { year:"numeric", month:"long", day:"numeric", hour:"numeric", minute:"numeric", second:"numeric"})
  }

  const handleSeekHover = (e) => {
    // Calculate the hovered value based on mouse position
    const boundingRect = slider.current.getBoundingClientRect()
    const percentage = (e.clientX - boundingRect.left) / boundingRect.width
    const hoveredValue = Math.round(percentage * slider.current.max)
    slider.current.title = formatTime(hoveredValue)
  }

  const handleSeekSelect = (e) => {
    e.preventDefault()
    player.current.currentTime = e.target.value
  }

  const togglePlaying = () => {
    if (playing) {
      setPlaying(false)
      player.current.pause()
    } else {
      setPlaying(true)
      player.current.play()
    }
  }

  const handleBackward = () => {
    player.current.currentTime -= 5
  }

  const handleForward = () => {
    player.current.currentTime += 5
  }

  const handleSpeed = (sp) => {
    player.current.playbackRate = sp
    setSpeed(sp)
    setShowSpeedOptions(false)
  }

  const toggleFullscreen = () => {
    if (fullscreen) {
      setFullscreen(false)
      setContextMenu([])
    } else {
      setFullscreen(true)
    }
  }

  const onRightClick = (e) => {
    e.preventDefault()
    if (fullscreen) {
      setContextMenu([e.clientY, e.clientX])
    }
  }

  return (
    <div style={styles.container}>
      <div style={{...styles.videoContainer, ...(fullscreen && {position: 'absolute', height: '100%'})}} onContextMenu={onRightClick}>
        <video ref={player} poster={player_poster} width="100%" height="100%" style={styles.video}
          autoPlay muted playsInline disablePictureInPicture
          onClick={() => props.selectedVideoPlaying && props.selectedVideoPlayingUrl ? togglePlaying() : null} >
        </video>

        {props.selectedVideoPlaying && props.selectedVideoPlaying.sDeviceID &&
          <div style={styles.overlayTimestamp}>
            {formatTS(props.selectedVideoPlaying.convertedTS.substring(0, 19))}
          </div>
        }
        {props.selectedVideoPlaying && props.selectedVideoPlaying.sTags && props.selectedVideoPlaying.sTags.length > 1 &&
          <div style={styles.overlayTags}>
            {props.selectedVideoPlaying.sTags.split(',').includes('vehicle') && <FaCar />}
            {props.selectedVideoPlaying.sTags.split(',').includes('person') && <FaMale />}
          </div>
        }
        {contextMenu.length > 1 && <div style={{...styles.contextMenu, top: contextMenu[0], left: contextMenu[1]}} onClick={toggleFullscreen}>Exit Fullscreen</div>}
      </div>

      {/* player buttons */}
      {videoLoaded &&
        <div style={styles.footer}>
          <div style={styles.seeker}>
            <div>{time + ' / ' + formatTime(player.current.duration)}</div>
            <input ref={slider} style={styles.slider} type="range" min={0} max={Math.round(player.current.duration)} step={1} value={Math.round(player.current.currentTime)}
              onMouseMove={handleSeekHover} onInput={handleSeekSelect} />
          </div>
          <div style={styles.buttons}>
            <FaBackward style={styles.button} onClick={handleBackward} />
            <div>
              {playing
                ? <FaPause style={styles.button} onClick={togglePlaying} />
                : <FaPlay style={styles.button} onClick={togglePlaying} />
              }
            </div>
            <FaForward style={styles.button} onClick={handleForward} />
            <div>
              <div style={{...styles.button, ...styles.speedButton}} onClick={() => setShowSpeedOptions(true)}>{speed}x</div>
              {showSpeedOptions &&
                <div style={styles.speedOptions}>
                  {speeds.map(s => <div key={s} style={{...styles.button, ...styles.speedButton}} onClick={() => handleSpeed(s)}>{s}x</div>)}
                </div>
              }
            </div>
            <div>
              {fullscreen
                ? <FaCompress style={styles.button} onClick={toggleFullscreen} />
                : <FaExpand style={styles.button} onClick={toggleFullscreen} />
              }
            </div>
          </div>
        </div>
      }
    </div>
  )
}

const mapStateToProps = state => {
  const { devices } = state.data
  const { selectedVideoPlaying, selectedVideoPlayingUrl } = state.playback

  return {
    devices,
    selectedVideoPlaying,
    selectedVideoPlayingUrl,
  }
}
export default connect(mapStateToProps)(VideoPlayer)

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1vmin',
    height: '75vh',
  },
  overlayTimestamp: {
    position: 'absolute',
    top: 0,
    zIndex: 10,
    padding: '.5vmin 1vmin',
  },
  overlayTags: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 10,
    padding: '.5vmin 1vmin',
    fontSize: '2vmin',
  },
  videoContainer: {
    position: 'relative',
    height: '64vh',
    width: '100%',
    top: 0,
    left: 0,
    zIndex: 100,
  },
  video: {
    objectFit: 'fill',
  },
  contextMenu: {
    position: 'absolute',
    zIndex: 101,
    backgroundColor: 'lightgrey',
    color: 'black',
    cursor: 'pointer',
    padding: 20,
  },
  footer: {
    width: '100%',
  },
  seeker: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1vmin',
  },
  slider: {
    width: '85%',
  },
  buttons: {
    height: '5vh',
    display: 'flex',
    justifyContent: 'center',
    gap: '1vw',
  },
  button: {
    width: '5vmin',
    height: '5vmin',
    padding: '1vmin',
    backgroundColor: 'rgba(0,0,0,0.7)',
    border: '1px solid white',
    borderRadius: 5,
    cursor: 'pointer',
  },
  speedButton: {
    padding: '1vmin 0',
    fontSize: '2vmin',
    textAlign: 'center',
  },
  speedOptions: {
    position: 'absolute',
    bottom: '14vh',
    display: 'flex',
    flexDirection: 'column-reverse',
    zIndex: 101,
  },
}